import { render } from "./provided.vue?vue&type=template&id=54aa2cc2"
import script from "./provided.vue?vue&type=script&lang=js"
export * from "./provided.vue?vue&type=script&lang=js"

import "./provided.vue?vue&type=style&index=0&id=54aa2cc2&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__